<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="saved-articles">
        <div  v-if="savedArticles" class="saved-articles-body  news-container">
            <div class="row">
                <NewsView :saved="true" :userHome="true" v-for="postInfo in savedArticles" :postInfo="postInfo" :key="postInfo"/>
            </div>
        </div>
        <div class="saved-articles-body  news-container empty-box"  v-else>
                (محتوایی یافت نشد)
        </div>
    </div>
    <PanelLoader v-if="loadingMood"/>

</template>

<script>
    import axios from 'axios'
    import Alert from "../../components/Alert"
    import NewsView from '../../components/NewsView'
    import PanelLoader from "../../components/PanelLoader"
    export default {
        name: "SavedArticles",
        data(){
            return{
                alertContent: null,
                loadingMood: false,
                savedArticles:null,
            }
        },
        methods:{
            async getData() {
                try {
                    this.loadingMood = true;
                    const response = await axios.get('api/userDashboard/getSavedArticles', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood = false;
                    this.savedArticles = response.data.results;
                } catch (error) {
                    this.loadingMood = false;
                    this.alertContent = {
                        message: 'خطا در انجام عملیات!',
                        imageUrl: require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType: 'close',//close
                        buttonText: 'تایید',
                        buttonLink: '',///personal-info
                        waitingMode: false
                    };
                }
            },
        },
        components:{
            NewsView,
            Alert,
            PanelLoader
        },
        mounted() {
            this.getData();
        }
    }
</script>

<style lang="scss"  scoped>
    .row{
        padding: 0 10px;
    }
    .empty-box{
        width: 100%;
        background-color: #f5f6fa;
        display: flex;
        justify-content: center;
        align-items: center;



        opacity: 0.7;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
        padding: 11px 10px;
        cursor: pointer;
        transition: all 0.1s ease;
        border-radius: 10px;


    }

    .news-container{
        overflow:hidden;
        overflow-y: scroll;
        width: 100%;
        height: 500px;
        margin: 0;
    }


    /*.news-container::-webkit-scrollbar {*/
        /*display: none;*/
        /*width: 2px;*/
    /*}*/

    /*!* Hide scrollbar for IE, Edge and Firefox *!*/
    /*.news-container {*/
        /*-ms-overflow-style: none;  !* IE and Edge *!*/
        /*scrollbar-width: none;  !* Firefox *!*/
    /*}*/








    .form-title {
        font-size: 22px !important;
    }
    /**title arrow**/

    #saved-articles{
        /*margin-top: 37px;*/
        /*margin-bottom: 37px;*/

        width: 100%;
        height: 100%;
        padding:30px 30px 0 30px;
    }

</style>